export default "__VITE_ASSET__V3wMe9Ju__"